import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '../button/button.module';
import { FieldModule } from '../field/field.module';
import { InputBoxComponent } from './input-box.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FieldModule, ButtonModule],
  declarations: [InputBoxComponent],
  exports: [InputBoxComponent],
})
export class InputBoxModule {}
